import { FC, Fragment, useEffect, useState } from 'react';

import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { useModalContext } from '../../../hooks/contexts/modal.context';
import { useUserContext } from '../../../hooks/contexts/user.context';
import AwaitingResponse from '../AlertModalAwaitingResponse';
import * as Styles from './styles.alertModal';

type AlertModalContentProps = {
  isMandatory: boolean;
  associateTheTicketForMe: () => string
}

const AlertModalContent: FC<AlertModalContentProps> = ({ isMandatory, associateTheTicketForMe }) => {
  const [awaiting, setAwaiting] = useState(false);

  const { translate } = useI18nContext();
  const { rfData, rFCheckWasSuccessful } = useUserContext();
  const { toggleModal } = useModalContext();

  useEffect(() => {
    if (rFCheckWasSuccessful) {
      associateTheTicketForMe();
    }
  }, [rFCheckWasSuccessful]);

  return (
    <Styles.WrapperAlert>
      {
        awaiting ? (
          <AwaitingResponse />
        ) : (
          <Fragment>
            <Styles.ContainerText>
              <Styles.TextInfo>
                {translate(['INFORMATION', 'FACIAL_BIOMETRY_REGISTRATION_BENEFITS'])}
              </Styles.TextInfo>
              <Styles.TextInfo>
                {translate(['INFORMATION', 'ONE_TIME_REGISTRATION_BENEFIT'])}
              </Styles.TextInfo>
            </Styles.ContainerText>
            <Styles.WrapperButton>
              {!isMandatory && (
                <Styles.Button
                  $type='latter'
                  onClick={() => {
                    associateTheTicketForMe();
                    toggleModal({ open : false });
                  }
                  }
                >
                  {translate(['INFORMATION', 'REGISTER_LATER'])}
                </Styles.Button>)}
              <Styles.Button
                $type='now'
                onClick={() => {
                  if (!rfData) {
                    throw new Error('onboarding_url is not defined');
                  }
                  setAwaiting(true);
                  window.open(rfData.onboarding_url, '_blank');
                }}
              >
                {translate(['INFORMATION', 'REGISTER_NOW'])}
              </Styles.Button>
            </Styles.WrapperButton>
          </Fragment>
        )
      }
    </Styles.WrapperAlert>
  );
};

export default AlertModalContent;
